<template>
  <div>
    <!-- 搜索框和添加按钮 -->
    <el-row :gutter="20" class="search-and-add-row">
      <el-col :span="8">
        <el-input v-model="searchQuery" placeholder="请输入查询内容" size="small" style="width: 100%;" />
      </el-col>
       <el-col :span="8">
        <el-button type="primary" size="small" @click="fetchData">搜索</el-button>
      </el-col>
      <el-col :span="6">
        <el-button type="primary" size="small" @click="showAddDialog">添加问题</el-button>
      </el-col>
    </el-row>

    <!-- 数据表格 -->
    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column prop="id" label="编号" width="100" />
      <el-table-column prop="question" label="问题" />
      <el-table-column prop="answer" label="答案" />
      <el-table-column prop="score" label="分数" width="100" />
      <el-table-column prop="type" label="题型" width="100" />
      <el-table-column prop="createdAt" label="创建时间" width="180" />
      <el-table-column prop="updatedAt" label="更新时间" width="180" />
      <el-table-column label="操作" width="200">
        <template #default="scope">
          <el-button type="primary" size="small" @click="editRecord(scope.row)">编辑</el-button>
          <el-button type="danger" size="small" @click="deleteRecord(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @current-change="handlePageChange"
      @size-change="handleSizeChange"
      :current-page="pagination.page"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      layout="total, sizes, prev, pager, next"
    />

    <!-- 添加/编辑弹窗 -->
    <el-dialog v-model="dialogVisible" :title="isEdit ? '编辑问题' : '添加问题'" width="50%">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="120px">
        <el-form-item label="问题" prop="question">
          <el-input v-model="form.question" />
        </el-form-item>
        <el-form-item label="答案" prop="answer">
          <template v-if="form.type === '选择题'">
            <el-checkbox-group v-model="form.answer">
              <el-checkbox v-for="(option, index) in form.options" :key="index" :label="option">{{ option }}</el-checkbox>
            </el-checkbox-group>
          </template>
          <template v-else>
            <el-input v-model="form.answer" />
          </template>
        </el-form-item>
        <el-form-item label="分数" prop="score">
          <el-input-number v-model="form.score" min="0" />
        </el-form-item>
        <el-form-item label="题型" prop="type">
          <el-select v-model="form.type" :disabled="isEdit" placeholder="请选择题型">
            <el-option label="选择题" value="选择题" />
            <el-option label="填空题" value="填空题" />
          </el-select>
        </el-form-item>

        <!-- 动态选项编辑 -->
        <el-form-item v-if="form.type === '选择题'" label="选项" prop="options">
          <div v-for="(option, index) in form.options" :key="index" class="option-item">
            <el-input v-model="form.options[index]" style="width: 80%;" placeholder="请输入选项" />
            <el-button type="danger" icon="el-icon-delete" @click="removeOption(index)" />
          </div>
          <el-button type="primary" plain icon="el-icon-plus" @click="addOption">添加选项</el-button>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveForm">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage } from "element-plus";
import axios from "@/axios";

export default {
  props: {
    userid: {
      type: Number,
      required: true,
    },
    organizationID: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      searchQuery: "",
      tableData: [],
      pagination: {
        page: 1,
        pageSize: 5,
        total: 0,
      },
      dialogVisible: false,
      isEdit: false,
      form: {
        id: null,
        question: "",
        answer: [],
        score: 0,
        type: "",
        options: [], // 始终使用数组管理选项
        organizationId: this.organizationID,
      },
      rules: {
        question: [{ required: true, message: "请输入问题", trigger: "blur" }],
        answer: [{ required: true, message: "请输入答案", trigger: "blur" }],
        score: [{ required: true, type: "number", message: "请输入分数", trigger: "blur" }],
        type: [{ required: true, message: "请选择题型", trigger: "change" }],
        options: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                callback(new Error("请至少添加一个选项"));
              } else if (value.some((option) => !option.trim())) {
                callback(new Error("选项内容不能为空"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    fetchData() {
      const { page, pageSize } = this.pagination;
      axios
        .get("/qs/qa", {
          params: {
            organizationID: this.organizationID,
            query: this.searchQuery || "",
            page: page ,
            size: pageSize,
          },
        })
        .then(({ data }) => {
          this.tableData = data.data;
          this.pagination.total = data.total;
        })
        .catch(() => ElMessage.error("获取数据失败"));
    },
    showAddDialog() {
      this.isEdit = false;
      this.form = { id: null, question: "", answer: [], score: 0, type: "", options: [], organizationId: this.organizationID };
      this.dialogVisible = true;
    },
    editRecord(row) {
      this.isEdit = true;
      this.form = {
        ...row,
        options: row.type === "选择题" ? row.options.split(",") : [],
        answer: row.type === "选择题" ? row.answer.split(",") : row.answer,
        organizationId: this.organizationID,
      };
      this.dialogVisible = true;
    },
    deleteRecord(id) {
      axios.delete(`/qs/${id}`).then((res) => {
        if (res.data.success) {
          ElMessage.success(res.data.data);
          this.fetchData();
        } else {
          ElMessage.error(res.data.errorMsg);
        }
      });
    },
    saveForm() {

      console.log(this.form.answer);
      if (this.$refs.formRef.validate()) {

        if(!this.form.score>0)
        {
          ElMessage.error("分数必须大于0");

          return;
        }
        if (this.form.answer == null ||this.form.answer.length === 0 || this.form.answer[0].trim() === "") {
          ElMessage.error("答案不能为空");
          return;
        }

        const method = this.isEdit ? "put" : "post";
        const url = "/qs";
        const payload = {
          ...this.form,
          options: this.form.type === "选择题" ? this.form.options.join(",") : "",
          // answer: this.form.type === "选择题" ? this.form.answer.filter(Boolean).join(",") : this.form.answer,
          answer: this.form.answer[0],
        };
        axios[method](url, payload)
          .then((res) => {
            if (res.data.success) {
              ElMessage.success(res.data.data);
              this.fetchData();
              this.dialogVisible = false;
            } else {
              ElMessage.error(res.data.errorMsg);
            }
          })
          .catch(() => ElMessage.error("保存失败"));
      }
    },
    handlePageChange(newPage) {
      this.pagination.page = newPage;
      this.fetchData();
    },
    handleSizeChange(newSize) {
      this.pagination.pageSize = newSize;
      this.fetchData();
    },
    addOption() {
      this.form.options.push(""); // 添加空选项
    },
    removeOption(index) {
      this.form.options.splice(index, 1); // 删除指定选项
    },
  },
  created() {
    this.fetchData();
    console.log(this.userid)
    console.log(this.organizationID)
  },
};
</script>

<style scoped>
.search-and-add-row {
  margin-bottom: 20px;
}
.option-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
</style>


